import React, { useContext } from "react";
import { DragAndDropContext } from "../../../context/DragAndDropContext";
import * as UTILS from "../../../utils/Utils";
import PropTypes from "prop-types";
import { Flex } from "antd";
import "./addElements.scss";
import {
    IconAccordion,
    IconButton,
    IconFile,
    IconForm,
    IconHTML,
    IconImage,
    IconLine,
    IconRowColumn,
    IconTable,
    IconText,
    IconTimer,
    IconVideo,
} from "../../../assets/images/toolbar/elements";
import { HolderOutlined } from "@ant-design/icons";

const icons = {
    Accordion: <IconAccordion />,
    Button: <IconButton />,
    File: <IconFile />,
    Form: <IconForm />,
    HTML: <IconHTML />,
    Image: <IconImage />,
    Line: <IconLine />,
    "Row / Column": <IconRowColumn />,
    Table: <IconTable />,
    Text: <IconText />,
    Timer: <IconTimer />,
    Video: <IconVideo />,
};

export const AddElements = () => {
    const { onDragStart, onDragEnd } = useContext(DragAndDropContext);
    return (
        <Flex vertical className="add-elements-container">
            {UTILS.tool.map((item, index) => {
                return (
                    <div
                        key={index}
                        id={index}
                        className="element-item"
                        draggable={true}
                        onDragStart={(e) => onDragStart(e, item, { data: 'toolbar' })}
                        onDragEnd={onDragEnd}
                    >
                        <Flex gap={6}>
                            <HolderOutlined />
                            <Flex>
                                {icons[item.name]}
                                {item.name}
                            </Flex>
                        </Flex>
                    </div>
                );
            })}
        </Flex>
    );
};

AddElements.propTypes = {
    onDrag: PropTypes.func,
};
